<script>
import { mapState, mapActions } from 'vuex'
import VueApexCharts from 'vue-apexcharts'

export default {
   components: {
      VueApexCharts,
   },
   data() {
      return {
         loading: false,
      }
   },
   computed: {
      ...mapState({
         dataResponse: state => state.DashboardSimbg.perKecamatan,
         tahun: state => state.DashboardSimbg.tahun,
         refreshTimestamp: state => state.DashboardSimbg.refreshTimestamp,
         skin: state => state.appConfig.layout.skin,
      }),
      isDark() {
         return this.skin === 'dark'
      },
      chartSeries() {
         return [
            {
               name: 'Total Dokumen',
               data: this.dataResponse.data.map(item => item.total),
            },
         ]
      },
      chartOptions() {
         const textColor = this.isDark ? '#b4b7bd' : '#6e6b7b'

         return {
            chart: {
               type: 'bar',
               foreColor: textColor,
               toolbar: {
                  show: false,
               },
               fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
               dropShadow: {
                  enabled: true,
                  top: 4,
                  left: 0,
                  blur: 6,
                  opacity: 0.15,
               },
            },
            colors: ['#7367f0'],
            fill: {
               type: 'gradient',
               gradient: {
                  shade: 'light',
                  type: 'vertical',
                  shadeIntensity: 0.25,
                  gradientToColors: ['#9e95f5'],
                  inverseColors: false,
                  opacityFrom: 1,
                  opacityTo: 0.85,
                  stops: [0, 100],
               },
            },
            plotOptions: {
               bar: {
                  borderRadius: 6,
                  columnWidth: '55%',
                  distributed: false,
               },
            },
            dataLabels: {
               enabled: false,
            },
            grid: {
               borderColor: this.isDark ? '#3b4253' : '#ebe9f1',
               strokeDashArray: 4,
               padding: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 10,
               },
            },
            xaxis: {
               categories: this.dataResponse.data.map(item => item.kecamatan),
               labels: {
                  rotate: -45,
                  style: {
                     colors: textColor,
                     fontSize: '11px',
                  },
               },
               title: {
                  text: 'Kecamatan',
                  style: {
                     color: textColor,
                  },
               },
            },
            yaxis: {
               min: 0,
               forceNiceScale: true,
               title: {
                  text: 'Jumlah Dokumen',
                  style: {
                     color: textColor,
                  },
               },
               labels: {
                  style: {
                     colors: [textColor],
                  },
                  formatter: value => Math.round(value),
               },
            },
            tooltip: {
               theme: this.isDark ? 'dark' : 'light',
               y: {
                  formatter: value => `${value} dokumen`,
               },
            },
         }
      },
   },
   watch: {
      tahun(newYear, oldYear) {
         if (newYear !== oldYear) this.loadPerKecamatan(newYear)
      },
      refreshTimestamp() {
         this.loadPerKecamatan(this.tahun)
      },
   },
   mounted() {
      this.loadPerKecamatan(this.tahun)
   },
   methods: {
      ...mapActions({
         getPerKecamatan: 'DashboardSimbg/getPerKecamatan',
      }),
      async loadPerKecamatan(year) {
         this.loading = true
         try {
            await this.getPerKecamatan(year)
         } catch (error) {
            // Chart tetap menampilkan data kosong saat request gagal.
         } finally {
            this.loading = false
         }
      },
   },
}
</script>

<template>
   <b-row>
      <b-col cols="12">
         <b-card class="card-wrapper">
            <b-overlay
               :show="loading"
               :variant="isDark ? 'dark' : 'white'"
               spinner-variant="primary"
               blur="0"
               opacity=".75"
               rounded="sm"
            >
               <div class="d-flex justify-content-between align-items-center mb-1">
                  <div>
                     <h4 class="mb-25">
                        PBG &amp; SLF Terbit per Kecamatan tahun {{ tahun }}
                     </h4>
                     <small class="text-muted">Jumlah dokumen per kecamatan</small>
                  </div>
               </div>
               <vue-apex-charts
                  type="bar"
                  height="420"
                  :options="chartOptions"
                  :series="chartSeries"
               />
            </b-overlay>
         </b-card>
      </b-col>
   </b-row>
</template>

<style scoped>
.card-wrapper {
   border: 0;
   border-radius: 12px;
   box-shadow: 0 4px 24px rgba(34, 41, 47, 0.08);
}
</style>
